import React from 'react';
import LabelInfo from '../../../../../components/LabelInfo';
import { setNumberWithComma } from '../../../../../lib/common';
import Panel from '../../../../../components/outline/Panel';
import './OrderCancelListSummaryBox.scss';

const OrderCancelListSummaryBox = (props) => {
  const { orderCancelSummaryBox } = props;

  return (
    <Panel className="order-cancel-list-summary-box">
      <div className="panel-body">
        <div className="order-cancel-list-summary-box-info">
          <div className="form-wrap">
            <LabelInfo
              label="입금 기한 초과 건수"
              info={setNumberWithComma(orderCancelSummaryBox.depositExpiredCnt, '건')}
            />

            <LabelInfo
              label="입금 기한 초과 합계 금액"
              info={setNumberWithComma(orderCancelSummaryBox.depositExpiredTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo label="취소 요청 건수" info={setNumberWithComma(orderCancelSummaryBox.cancelRequestCnt, '건')} />

            <LabelInfo
              label="취소 요청 합계 금액"
              info={setNumberWithComma(orderCancelSummaryBox.cancelRequestTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo label="취소 거부 건수" info={setNumberWithComma(orderCancelSummaryBox.cancelRejectCnt, '건')} />

            <LabelInfo
              label="취소 거부 합계 금액"
              info={setNumberWithComma(orderCancelSummaryBox.cancelRejectTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="취소 완료 건수"
              info={setNumberWithComma(orderCancelSummaryBox.cancelCompleteCnt, '건')}
            />

            <LabelInfo
              label="취소 완료 합계 금액"
              info={setNumberWithComma(orderCancelSummaryBox.cancelCompleteTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo label="환불 완료 건수" info={setNumberWithComma(orderCancelSummaryBox.refundDoneCnt, '건')} />

            <LabelInfo
              label="환불 완료 합계 금액"
              info={setNumberWithComma(orderCancelSummaryBox.refundDoneTotalPrice, '원')}
            />
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default OrderCancelListSummaryBox;
